import React, { useState, Fragment, useEffect } from "react";
import { useLocation, useHistory, Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Table, TableHead, TableBody } from "component/common/Table/index";
import ImageSlider from "component/common/ImageSlider/index";
import Pagination from "component/common/Pagination";
import DisputedFilter from "./DisputedFilter";
import SaveCancelBtn from "component/common/SaveCancelBtn";
import TextField from "component/common/TextField";
import ProductMedia from "component/common/ProductMedia";
import Loader from "component/common/Loader";
import {
  updateDispute,
  getAllDisputed,
  deleteDisputeById,
} from "service/Disputed";
import TextInput from "component/common/TextInput";
import queryString from "query-string";
import eye from "assets/images/eye.svg";
import edit from "assets/images/edit.svg";
import dustbin from "assets/images/dustbin.svg";

import styles from "./DisputedList.module.scss";
import { Toast } from "utils/toast";
import { getRoleAction } from "utils/helper";
import AddDispute from "./AddDispute";
import DeleteConfirmation from "component/common/DeleteConfirmation";
import NormalButton from "component/common/NormalButton";

const DisputedList = () => {
  const { handleSubmit, reset, setValue, clearErrors } = useForm();

  const location = useLocation();

  const history = useHistory();

  const head = [
    "Seller ID",
    "Sale Date",
    "Buyer Name",
    "Buyer Payment Information",
    "Total Amt",
    "Discount Amt",
    "Status",
    "Action",
  ];

  let [disputed, setDisputed] = useState(null);

  let [id, setId] = useState("");

  let [activeIndex, setActiveIndex] = useState(null);

  let [media, setMedia] = useState(false);

  let [totalPages, setTotalPages] = useState();

  const page = new URLSearchParams(location.search).get("page");

  const sort = new URLSearchParams(location.search).get("sort");

  const sellerId = new URLSearchParams(location.search).get("sellerId");

  const status = new URLSearchParams(location.search).get("paymentStatus");

  const buyer = new URLSearchParams(location.search).get("buyer");

  let [imageUrl, setImageUrl] = useState([]);

  let [confirmation, setConfirmation] = useState(false);

  let [showModal, setShowModal] = useState(false);
  let [editModal, setEditModal] = useState(false);

  const { isOperationAvailable } = getRoleAction("Dispute");

  useEffect(() => {
    getDisputed();
  }, [location.search]);

  const getDisputed = async () => {
    let params = {
      sellerId_by_user: sellerId,
      page: page != null ? page : 1,
      paymentStatus: status,
      buyerName: buyer,
      total_amount: sort,
    };
    try {
      let response = await getAllDisputed(params);
      if (response.status == 200) {
        setDisputed(response.data.data.data);
        setTotalPages(response.data.data.pageMeta.totalPages);
      }
    } catch (error) {
      Toast({ type: "error", message: error?.data?.message });
    }
  };

  const toggleAccordian = (index = null) => {
    setActiveIndex(index);
  };

  const onSubmit = async (data) => {
    let body = {
      status: data.status,
    };
    if (data.status === "Discounted") {
      body.discountAmount = data.discountAmount;
    } else if (data.status === "Refunded") {
      body.discountAmount = disputed[activeIndex].salePrice;
    }
    try {
      let response = await updateDispute(id, body);
      if (response.status == 200) {
        onCancel();
        getDisputed();
      }
    } catch (error) {
      Toast({ type: "error", message: error?.data?.message });
    }
  };

  const handlePageChange = (event) => {
    let params = queryString.stringify({
      status: status ? status : undefined,
      buyerName: buyer ? buyer : undefined,
      sortPrice: sort ? sort : undefined,
      sellerId: sellerId ? sellerId : undefined,
    });
    if (params === "") {
      history.push(`/admin/dispute/list?page=${event}`);
    } else {
      history.push(`/admin/dispute/list?${params}&page=${event}`);
    }
  };

  const toggleMedia = (url = []) => {
    setMedia(!media);
    setImageUrl(url);
  };

  const onEdit = (data) => {
    reset({
      discountAmount: data.discountAmount === "" ? "" : data.discountAmount,
    });
    setValue("status", data.status === "N.A" ? "" : data.status);
    setId(data._id);
    if (data.status !== "N.A" || data.status !== "") {
      clearErrors("status");
    }
  };

  const onCancel = () => {
    setId("");
    toggleAccordian();
  };

  const toggleConfirmation = () => {
    setConfirmation(!confirmation);
  };

  const showConfirmation = (id) => {
    setId(id);
    toggleConfirmation();
  };

  const showModalFunc = (data, editTrue, id) => {
    setShowModal(data);
    if (editTrue) {
      setId(id);
      setEditModal(true);
    }
  };

  const onDelete = async () => {
    try {
      let body = {
        buyerId: id,
      };
      let response = await deleteDisputeById(body);
      if (response) {
        toggleConfirmation();
        Toast({
          type: "success",
          message: "Disupte has been deleted successfully",
        });
        getDisputed();
        setId(id);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const handleHistory = () => {
    history.push(`/admin/dispute/dispute-history`);
  };

  if (disputed == null) return <Loader />;

  return (
    <>
      <div className="row mb-2">
        <div className="col-md-12">
          <div className={styles.disputed_title}>
            <b>Dispute</b>
          </div>
        </div>
      </div>
      <div className="row mb-2">
        <div className="col-md-12 d-flex justify-content-end align-items-center mt-2">
          {isOperationAvailable("Dispute History") && (
            <div className="mr-3">
              <NormalButton label="Dispute History" onClick={handleHistory} />
            </div>
          )}
          {/* {isOperationAvailable("Add Dispute") ||
            (isOperationAvailable("Edit") && (
          
            ))} */}
          <AddDispute
            getDisputed={getDisputed}
            showModal={showModal}
            showModalData={(data) => showModalFunc(data)}
            editModal={editModal}
            viewPage={false}
            id={id}
            setEditModal={setEditModal}
          />
        </div>
      </div>
      <Table>
        <TableHead className={styles.disputed_head} head={head} />
        <DisputedFilter />
        <TableBody>
          {disputed.length !== 0 ? (
            disputed?.map((list, index) => {
              return (
                <Fragment key={index}>
                  <tr key={index} className={styles.disputed_body}>
                    <td>{list.sellerId_by_user}</td>
                    <td>{list.sale_date}</td>
                    <td>{list.buyerName || "-"}</td>
                    <td>
                      {list?.bankDetails.accountNumber === "" ? (
                        <div>
                          {list?.UPICode?.map((item) => (
                            <td className={styles.overflow_any}>{item?.upi}</td>
                          ))}
                        </div>
                      ) : (
                        <div>
                          <td className={styles.overflow_any}>
                            {list?.bankDetails.accountNumber}
                          </td>
                        </div>
                      )}
                    </td>
                    <td>
                      {list.total_amount === ""
                        ? "N.A"
                        : `₹${list.total_amount}`}
                    </td>
                    <td>
                      {list.discount_amount === ""
                        ? "N.A"
                        : `₹${list.discount_amount}`}
                    </td>
                    <td className="text-capitalize">
                      {list?.paymentStatus || "-"}
                    </td>
                    <td>
                      <UncontrolledDropdown>
                        <DropdownToggle tag="span" data-toggle="dropdown">
                          <i className="icon-dots"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                          {isOperationAvailable("View") && (
                            <Link
                              to={`/admin/dispute/viewdispute/${list?.buyerId}`}
                            >
                              <DropdownItem>
                                <div className="dropdown-items">
                                  <img src={eye} alt="view" />
                                  <span>View</span>
                                </div>
                              </DropdownItem>
                            </Link>
                          )}
                          {isOperationAvailable("Edit") && (
                            <DropdownItem
                              onClick={() =>
                                showModalFunc(true, "editTrue", list?.buyerId)
                              }
                            >
                              <div className="dropdown-items">
                                <img src={edit} alt="edit" />
                                <span>Edit</span>
                              </div>
                            </DropdownItem>
                          )}
                          {isOperationAvailable("Delete") && (
                            <DropdownItem
                              onClick={() => showConfirmation(list?.buyerId)}
                            >
                              <div className="dropdown-items">
                                <img src={dustbin} alt="delete" />
                                <span>Delete</span>
                              </div>
                            </DropdownItem>
                          )}
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </td>
                  </tr>
                  <tr
                    style={{
                      border:
                        activeIndex === index ? "1px solid #C4C4C4" : "none",
                    }}
                  >
                    <td colSpan="9" style={{ padding: "0px" }}>
                      <div
                        className="table-accordian"
                        style={{
                          maxHeight: activeIndex === index ? "600px" : "0px",
                        }}
                      >
                        <div className={styles.dispute_accordian}>
                          <div style={{ width: "180px" }}>
                            <ImageSlider
                              url={list.disputeImageUrl}
                              next="image-next"
                              prev="image-prev"
                              toggle={() => toggleMedia(list.disputeImageUrl)}
                            />
                          </div>
                          <div className="w-100 row">
                            <div className="col-md-12 mb-4">
                              <TextInput
                                label="Reason for Dispute"
                                value={list.reason}
                                disabled={true}
                                color="#222529"
                              />
                            </div>
                            <div className="col-md-12">
                              <TextField
                                label="Comments"
                                value={list.comments}
                                disabled={true}
                                color="#222529"
                              />
                            </div>
                            <div className="col-md-12">
                              {list._id !== id ? (
                                <div className={styles.disputed_edit}>
                                  <button onClick={() => onEdit(list)}>
                                    EDIT
                                  </button>
                                </div>
                              ) : (
                                <SaveCancelBtn
                                  onCancel={() => onCancel()}
                                  onSave={handleSubmit(onSubmit)}
                                  margin={10}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </Fragment>
              );
            })
          ) : (
            <tr>
              <td colSpan="9" className="no-record">
                <span>No Records Found</span>
              </td>
            </tr>
          )}
        </TableBody>
      </Table>
      {totalPages > 1 && (
        <Pagination
          totalPages={totalPages}
          activePage={page != null ? page : 1}
          onPageChange={handlePageChange}
        />
      )}
      <ProductMedia
        url={imageUrl}
        isOpen={media}
        toggle={() => toggleMedia()}
        showAction={false}
      />
      <DeleteConfirmation
        message="Are you sure to delete this Dispute?"
        isOpen={confirmation}
        toggle={toggleConfirmation}
        onSubmit={onDelete}
      />
    </>
  );
};

export default DisputedList;
